import { Injectable } from '@angular/core';
import { get } from 'lodash';

import { ADPolicyState } from 'src/app/constants/ad-policy.constants';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { SmartAssistService } from 'src/app/services/smart-assist/smart-assist.service';

@Injectable({
  providedIn: 'root'
})
export class IntelligentScreenDefaultValueService {

  SLIDER_DEFAULT_VALUE:number = 15;
  constructor(private smartAssist: SmartAssistService, private logger:LoggerService) { }

  initialize(adTags: any): void {
	const smartAssistIntelligentScreen = get(adTags, DeviceSettingsFeatureToggle.SmartAssistIntelligentScreen);
	const isADPolicyEnabled = smartAssistIntelligentScreen === ADPolicyState.ENABLED;
	const isAvailableSmartAssist = this.smartAssist.isShellAvailable;

	if(isADPolicyEnabled && isAvailableSmartAssist) {
		this.resetDefaultValue();
	}
  }

  private resetDefaultValue(): void {
	this.setDefaultAutoScreenOff();
	this.setDefaultkeepMyDisplay();
  }

  private async setDefaultAutoScreenOff() {
	try {
	  await this.smartAssist.setAutoScreenOffStatus(true);
	} catch (error) {
	  this.logger.error('SetDefaultAutoScreenOff: ', error);
	}
  }

  private async setDefaultkeepMyDisplay() {
	try {
	  const keepMyDisplayCapability = await this.smartAssist.getReadingOrBrowsingVisibility();

	  if(keepMyDisplayCapability) {
		await this.smartAssist.setReadingOrBrowsingStatus(true);
		this.smartAssist.setReadingOrBrowsingTime(this.SLIDER_DEFAULT_VALUE);
	  }
	} catch (error) {
	  this.logger.error('setDefaultkeepMyDisplay: ', error);
	}
  }
}
